import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedReorder202604: FaireAdPerformancePeriodEntity =
  {
    token: "perf_p4_under_utilized_reorder_202604",
    type: "adPerformancePeriod",
    scope: "REORDER_MARKETPLACE",
    periodType: "RECEIPT",
    startDate: "2026-04-01",
    endDate: "2026-04-30",
    impressions: 4437,
    clicks: 52,
    adsSpendDollars: 231,
    budgetDollars: 500,
    salesDollars: 2301,
    bestEstimateRoas: 9.96,
    bestEstimateType: "ACTUALIZED",
    budgetUtilization: 0.46,
    reorderConversions: 7,
    dataAvailableAtDate: "2026-05-04",
    meta: {
      source: "mock",
      importedAt: "2026-07-06T00:00:00.000Z",
      importedBy: "advertiser-profiles",
    },
  };
